import type {
  OperationLog,
  OperationLogDetail,
  OperationLogListQuery,
  OperationLogPage,
  OperationLogPort,
} from './operationLogPort';

const demoLogs: OperationLogDetail[] = [
  {
    id: 'demo-log-package-20261030-1024',
    actorUserId: 'demo-sales-001',
    actorName: '演示·林佳',
    occurredAt: '2026-10-30T02:24:00.000Z',
    resourceType: 'package',
    resourceId: 'demo-package-live-audio',
    resourceName: '本地演示｜直播活动音响套餐',
    action: 'package.revision.create',
    source: 'direct',
    hasDetails: true,
    historyStatus: 'complete',
    changes: [
      {
        field: 'name',
        label: '套餐名称',
        before: '直播活动音响套餐',
        after: '直播活动音响套餐（含返听）',
      },
      {
        field: 'packageMonthlyTotalCents',
        label: '套餐月租合计',
        before: 328000,
        after: 368000,
      },
      { field: 'quantity', label: '设备数量', before: 5, after: 6 },
    ],
    references: [
      {
        resourceType: 'equipment',
        resourceId: 'demo-speaker-main',
        currentName: '线阵主扩音箱',
      },
      {
        resourceType: 'equipment',
        resourceId: 'demo-speaker-monitor',
        currentName: '舞台返听音箱',
      },
    ],
  },
  {
    id: 'demo-log-plan-20261030-1016',
    actorUserId: 'demo-admin-001',
    actorName: '演示·周主管',
    occurredAt: '2026-10-30T02:16:00.000Z',
    resourceType: 'plan',
    resourceId: 'demo-plan-product-launch',
    resourceName: '本地演示｜新品发布会方案',
    action: 'plan.package_memberships.replace',
    source: 'direct',
    hasDetails: true,
    historyStatus: 'complete',
    changes: [
      {
        field: 'items',
        label: '方案套餐',
        before: [{ name: '基础音响套餐', quantity: 1 }],
        after: [
          { name: '直播活动音响套餐（含返听）', quantity: 1 },
          { name: '舞台灯光套餐', quantity: 1 },
        ],
      },
      {
        field: 'pricingCoefficient',
        label: '方案专属折扣',
        before: '0.92',
        after: '0.9',
      },
    ],
    references: [
      {
        resourceType: 'package',
        resourceId: 'demo-package-live-audio',
        currentName: '直播活动音响套餐（含返听）',
      },
    ],
  },
  {
    id: 'demo-log-equipment-20261030-0945',
    actorUserId: 'demo-catalog-001',
    actorName: '演示·陈工',
    occurredAt: '2026-10-30T01:45:00.000Z',
    resourceType: 'equipment',
    resourceId: 'demo-led-screen-3x2',
    resourceName: '本地演示｜P3.9 LED 屏（3×2 米）',
    action: 'equipment.images.replace',
    source: 'direct',
    hasDetails: true,
    historyStatus: 'complete',
    changes: [
      {
        field: 'images',
        label: '设备图片',
        before: ['正面效果图.jpg'],
        after: ['正面效果图.jpg', '侧面接口图.jpg', '安装示意图.jpg'],
      },
      {
        field: 'isPrimary',
        label: '主图',
        before: '正面效果图.jpg',
        after: '正面效果图.jpg',
      },
    ],
  },
  {
    id: 'demo-log-pool-20261030-0933',
    actorUserId: 'demo-catalog-001',
    actorName: '演示·陈工',
    occurredAt: '2026-10-30T01:33:00.000Z',
    resourceType: 'replacement_pool',
    resourceId: 'demo-pool-wireless-mic',
    resourceName: '无线手持麦克风平替池',
    action: 'replacement_pool.update',
    source: 'direct',
    hasDetails: true,
    historyStatus: 'complete',
    changes: [
      {
        field: 'name',
        label: '平替池名称',
        before: '无线麦克风替换设备',
        after: '无线手持麦克风平替池',
      },
      { field: 'sortOrder', label: '优先级', before: 2, after: 1 },
    ],
  },
  {
    id: 'demo-log-package-propagation-20261030-0912',
    actorUserId: 'demo-admin-001',
    actorName: '演示·周主管',
    occurredAt: '2026-10-30T01:12:00.000Z',
    resourceType: 'package',
    resourceId: 'demo-package-presentation',
    resourceName: '本地演示｜会议投影套餐',
    action: 'package.media_repair',
    source: 'propagation',
    hasDetails: true,
    cause: {
      resourceType: 'equipment',
      resourceId: 'demo-projector-4k',
      revisionId: 'demo-revision-4k',
    },
    historyStatus: 'partial',
    changes: [
      {
        field: 'images',
        label: '关联设备图片',
        before: ['旧款投影机.jpg'],
        after: ['4K 投影机正面.jpg', '接口图.jpg'],
      },
    ],
    references: [
      {
        resourceType: 'equipment',
        resourceId: 'demo-projector-4k',
        currentName: '4K 激光投影机',
      },
    ],
  },
  {
    id: 'demo-log-order-20261029-1650',
    actorUserId: 'demo-sales-001',
    actorName: '演示·林佳',
    occurredAt: '2026-10-29T08:50:00.000Z',
    resourceType: 'order_confirmation',
    resourceId: 'LOCAL-DEMO-QUOTE-SUBMIT-SUCCESS',
    resourceName: '【本地演示】下单确认',
    action: 'order.confirmation.confirm',
    source: 'direct',
    hasDetails: false,
    historyStatus: 'unavailable',
    changes: [],
  },
];

function matchesQuery(record: OperationLog, query: OperationLogListQuery) {
  if (query.resourceType && record.resourceType !== query.resourceType)
    return false;
  if (query.actorUserId && record.actorUserId !== query.actorUserId.trim())
    return false;
  const occurredAt = Date.parse(record.occurredAt);
  if (query.from && occurredAt < Date.parse(query.from)) return false;
  if (query.to && occurredAt >= Date.parse(query.to)) return false;
  const term = query.search?.trim().toLocaleLowerCase();
  return (
    !term ||
    [
      record.actorName,
      record.actorUserId,
      record.resourceName,
      record.resourceId,
      record.action,
    ].some((value) => value?.toLocaleLowerCase().includes(term))
  );
}

function abortIfNeeded(signal?: AbortSignal) {
  if (signal?.aborted) throw new DOMException('请求已取消', 'AbortError');
}

export function createLocalDemoOperationLogApi(): OperationLogPort {
  return {
    async list(query, signal): Promise<OperationLogPage> {
      abortIfNeeded(signal);
      const filtered = demoLogs.filter((record) => matchesQuery(record, query));
      const start = Math.max(0, query.page - 1) * query.pageSize;
      return {
        items: filtered
          .slice(start, start + query.pageSize)
          .map(
            ({
              changes: _changes,
              references: _references,
              historyStatus: _historyStatus,
              ...row
            }) => ({ ...row }),
          ),
        total: filtered.length,
        page: query.page,
        pageSize: query.pageSize,
      };
    },
    async detail(logId, signal): Promise<OperationLogDetail> {
      abortIfNeeded(signal);
      const record = demoLogs.find((item) => item.id === logId);
      if (!record) throw new Error('找不到这条本地演示操作日志。');
      return structuredClone(record);
    },
  };
}
